import { render, staticRenderFns } from "./fileTab.vue?vue&type=template&id=0722d6d1&scoped=true"
import script from "./fileTab.vue?vue&type=script&lang=js"
export * from "./fileTab.vue?vue&type=script&lang=js"
import style0 from "./fileTab.vue?vue&type=style&index=0&id=0722d6d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0722d6d1",
  null
  
)

export default component.exports